(function () {
    'use strict';

    angular.module('app')
        .factory('FuenteTipoService', FuenteTipoService);

    /* @ngInject */
    function FuenteTipoService($resource) {
        return $resource('api/public/divisa/tipo-fuente', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
